import { Icon } from "@iconify/react";
import React from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { useParams } from "react-router-dom";
// material
import {
  Box,
  Card,
  Table,
  Stack,
  Button,
  IconButton,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Paper,
  TablePagination,
} from "@mui/material";
import Swal from "sweetalert2";

// components
import Label from "../components/Label";
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import Iconify from "../components/Iconify";
import NuevoElementoCarrusel from "../components/NuevoElementoCarrusel";
import { Api } from "../app-controller";

// ----------------------------------------------------------------------
const host = window.location.host.split(":")[0];

const tableHead = [
  { id: "titulo", label: "Título", alignRight: false },
  { id: "status", label: "Estado", alignRight: false },
  { id: "opciones", label: "Opciones", alignRight: true },
];

const title = "Nuevo";

class Layout extends React.Component {
  constructor(props) {
    super();
    const { id } = props.params;
    this.inicialState = {
      elementoInfo: {
        titulo: "",
        resumen: "",
        imagen: null,
        switchValue: false,
        link: "",
        contenido: "",
      },
      mensajeError: {
        error: false,
        mensaje: "",
      },
      mensajeErrorSubmit: {
        error: false,
        mensaje: "",
      },
    };

    this.state = {
      carrusel: [],
      elementoInfo: this.inicialState.elementoInfo,
      rpeInfo: [],
      rpeID: id,
      notFound: false,
      modalShow: false,
      // carga: true,
      editar: false,
      view: false,
      nuevo: false,
      mensajeError: this.inicialState.mensajeError,
      mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit,
    };
  }

  componentDidMount() {
    this.setElementos();
  }

  setElementos = () => {
    const id = this.state.rpeID;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.token}`,
      },
    };

    fetch(`${Api.url}getElementosCarrusel?id=${id}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(response.status);
      })
      .then((data) => {
        if (data) {
          const auxNotFound = data.carrusel.length === 0;

          this.setState({
            carrusel: data.carrusel,
            rpeInfo: data.rpeInfo,
            notFound: auxNotFound,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No tiene acceso a ésta información",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/admin/inicio";
          }
        });
      });
  };

  handleOpen = (e) => {
    if (e) this.setState({ nuevo: true });
    this.setState({ modalShow: true });
  };

  handleClose = (e) => {
    this.setState({
      modalShow: false,
      nuevo: false,
      editar: false,
      view: false,
      elementoInfo: this.inicialState.elementoInfo,
      mensajeError: this.inicialState.mensajeError,
      mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit,
    });
  };

  handleAddElemento = (e, data) => {
    e.preventDefault();
    this.setState({ mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit });

    const postData = this.state.elementoInfo;
    postData.rpeID = this.state.rpeID;

    if (
      postData.imagen === null ||
      (postData.switchValue === false && postData.contenido === "") ||
      postData.contenido === "<p><br></p>"
    ) {
      const mensaje =
        postData.imagen === null
          ? "Favor de agregar imagen"
          : "Favor de agregar información";

      const mensajeErrorSubmit = {
        error: true,
        mensaje,
      };
      this.setState({ mensajeErrorSubmit });
    } else if (this.state.nuevo) {
      this.handleClose();
      Api.loading(true);

      const post = new FormData();
      const keys = Object.keys(postData);

      keys.forEach((key) => {
        post.append(key, postData[key]);
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.token}`,
        },
        body: post,
      };

      fetch(`${Api.url}createElementoCarrusel`, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
          throw new Error(response.status);
        })
        .then((data) => {
          Api.loading(false);

          Swal.fire({
            text: data.message,
            allowOutsideClick: false,
          });

          this.setElementos(); // Actualizo tabla de elementos
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: "No tiene acceso a ésta información",
            icon: "error",
            showCancelButton: false,
            cancelButtonColor: "green",
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/admin/inicio";
            }
          });
        });
    } else {
      this.handleClose();
      Api.loading(true);

      const post = new FormData();
      const keys = Object.keys(postData);

      keys.forEach((key) => {
        post.append(key, postData[key]);
      });
      post.append("_method", "PUT");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.token}`,
        },
        body: post,
      };

      fetch(`${Api.url}editElementoCarrusel`, requestOptions)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
          throw new Error(response.status);
        })
        .then((data) => {
          Api.loading(false);

          Swal.fire({
            text: data.message,
            allowOutsideClick: false,
          });

          this.setElementos(); // Actualizo tabla de elementos
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: "No tiene acceso a ésta información",
            icon: "error",
            showCancelButton: false,
            cancelButtonColor: "green",
            confirmButtonText: "Continuar",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/admin/inicio";
            }
          });
        });
    }
  };

  handleStatusElemento = (id) => {
    Swal.fire({
      icon: "question",
      title: "¿Está seguro de realizar la acción?",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const requestOptions = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.token}`,
          },
          body: JSON.stringify({ id }),
        };

        fetch(`${Api.url}deactivateElementoCarrusel`, requestOptions)
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            }
            throw new Error(response.status);
          })
          .then((data) => {
            Swal.fire({
              text: data.message,
              allowOutsideClick: false,
            });
            this.setElementos(); // Actualizo tabla de elementos
          })
          .catch((error) => {
            Swal.fire({
              title: "Error",
              text: "No tiene acceso a ésta información",
              icon: "error",
              showCancelButton: false,
              cancelButtonColor: "green",
              confirmButtonText: "Continuar",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/admin/inicio";
              }
            });
          });
      }
    });
  };

  handleChangeValueE = (e) => {
    const datos = { ...this.state.elementoInfo };

    switch (e.target.id) {
      case "titulo":
        datos.titulo = e.target.value;
        break;
      case "resumen":
        datos.resumen = e.target.value;
        break;
      case "imagen": {
        datos.imagen = null;
        const element = e.target;

        const file = element.files[0];
        if (file !== undefined) {
          const ext = file.type.split("/")[1];

          if (
            ext === "svg+xml" ||
            ext === "png" ||
            ext === "jpg" ||
            ext === "jpeg" ||
            ext === "svg"
          ) {
            this.setState({ mensajeError: this.inicialState.mensajeError });
            datos.imagen = file;

            if (
              this.state.mensajeErrorSubmit.error &&
              datos.switchValue === false &&
              (datos.contenido === "" || datos.contenido === "<p><br></p>")
            ) {
              const mensajeErrorSubmit = {
                error: true,
                mensaje: "Favor de agregar información",
              };
              this.setState({ mensajeErrorSubmit });
            } else {
              this.setState({
                mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit,
              });
            }
          } else {
            const mensajeError = {
              error: true,
              mensaje: "Tipo de archivo no aceptado",
            };
            this.setState({ mensajeError });
          }
        }
        break;
      }
      case "switch":
        datos.switchValue = e.target.checked;
        datos.link = "";
        datos.contenido = "";

        this.setState({
          mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit,
        });
        break;
      case "link":
        datos.link = e.target.value;
        break;
      default:
        break;
    }

    this.setStateElementoInfo(datos);
  };

  handleChangeEditor = (event) => {
    const datos = { ...this.state.elementoInfo };
    datos.contenido = event;

    if (this.state.mensajeErrorSubmit.error && datos.imagen === null) {
      const mensajeErrorSubmit = {
        error: true,
        mensaje: "Favor de agregar imagen",
      };
      this.setState({ mensajeErrorSubmit });
    } else if (event === "" || event === "<p><br></p>") {
      const mensajeErrorSubmit = {
        error: true,
        mensaje: "Favor de agregar información",
      };
      this.setState({ mensajeErrorSubmit });
    } else {
      this.setState({
        mensajeErrorSubmit: this.inicialState.mensajeErrorSubmit,
      });
    }

    this.setStateElementoInfo(datos);
  };

  setStateElementoInfo = (datos) => {
    this.setState({ elementoInfo: datos });
  };

  handleGetElementoEdit = (e, id, aux) => {
    e.preventDefault();

    if (aux) {
      this.setState({ editar: true });
    } else {
      this.setState({ view: true });
    }

    this.setElemento(id);
  };

  setElemento = (id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.token}`,
      },
    };

    fetch(`${Api.url}getElementoCarrusel?id=${id}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(response.status);
      })
      .then((data) => {
        if (data) {
          this.setState({ elementoInfo: data.elemento, modalShow: true });
          this.handleOpen();
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No tiene acceso a ésta información",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/admin/inicio";
          }
        });
      });
  };

  changeRowOrder = (id, up) => {
    Api.loading(true);
    const requestOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.token}`,
      },
    };

    fetch(
      `${Api.url}changeOrderRowCarrusel?id=${id}&rpeID=${this.state.rpeID}&up=${up}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        throw new Error(response.status);
      })
      .then((data) => {
        if (data) {
          this.setElementos();
          Api.loading(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: "No tiene acceso a ésta información",
          icon: "error",
          showCancelButton: false,
          cancelButtonColor: "green",
          confirmButtonText: "Continuar",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/admin/inicio";
          }
        });
      });
  };

  render() {
    return (
      <Page title={this.state.rpeInfo.descripcion}>
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Typography variant="h4" gutterBottom>
              Carrusel | {this.state.rpeInfo.descripcion}
            </Typography>
            <Box>
              <Button
                variant="contained"
                startIcon={<Icon icon={plusFill} />}
                onClick={() => this.handleOpen(true)}
              >
                Nuevo elemento
              </Button>
              <NuevoElementoCarrusel
                key="nuevo"
                title="elemento carrusel"
                isOpen={this.state.modalShow}
                handleChangeValueE={(e) => this.handleChangeValueE(e)}
                handleChangeEditor={(e) => this.handleChangeEditor(e)}
                handleAddElemento={(e) => this.handleAddElemento(e)}
                handleClose={() => this.handleClose()}
                info={this.state.elementoInfo}
                editar={this.state.editar}
                view={this.state.view}
                nuevo={this.state.nuevo}
                mensajeError={this.state.mensajeError}
                mensajeErrorSubmit={this.state.mensajeErrorSubmit}
              />
            </Box>
          </Stack>
          <Card>
            <Scrollbar>
              <TableContainer sx={{ minWidth: "100%" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell key="changeRow" align="center">
                        Orden
                      </TableCell>
                      {tableHead.map((headCell, index) => (
                        <TableCell key={index} align="left">
                          {headCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.carrusel.map((c, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">
                          <Stack>
                            {index !== 0 ? (
                              <IconButton
                                size="small"
                                onClick={() => this.changeRowOrder(c.id, true)}
                              >
                                <Iconify icon="eva:arrow-ios-upward-outline" />
                              </IconButton>
                            ) : null}

                            {index !== this.state.carrusel.length - 1 ? (
                              <IconButton
                                size="small"
                                onClick={() => this.changeRowOrder(c.id, false)}
                              >
                                <Iconify icon="eva:arrow-ios-downward-outline" />
                              </IconButton>
                            ) : null}
                          </Stack>
                        </TableCell>
                        <TableCell align="left">{c.titulo}</TableCell>
                        <TableCell align="left">
                          <Label
                            variant="ghost"
                            color={
                              (parseInt(c.status, 10) === 0 && "error") ||
                              "success"
                            }
                          >
                            {c.status_descripcion}
                          </Label>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            id="Ver-b"
                            onClick={(e) =>
                              this.handleGetElementoEdit(e, c.id, false)
                            }
                          >
                            <Iconify id="Ver" icon="eva:eye-outline" />
                          </IconButton>
                          <IconButton
                            id="Editar-b"
                            onClick={(e) =>
                              this.handleGetElementoEdit(e, c.id, true)
                            }
                          >
                            <Iconify id="Editar" icon="eva:edit-2-outline" />
                          </IconButton>
                          <IconButton
                            onClick={() => this.handleStatusElemento(c.id)}
                          >
                            {parseInt(c.status, 10) === 1 ? (
                              <Iconify icon="eva:close-fill" />
                            ) : (
                              <Iconify icon="eva:checkmark-outline" />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  {this.state.notFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper>
                            <Typography variant="body2" align="center">
                              No se encontraron resultados.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        </Container>
      </Page>
    );
  }
}
export default (props) => <Layout {...props} params={useParams()} />;
